import hospitalService from './hospitalService';

const institutionService = [
    ...hospitalService
]

export { institutionService as default, hospitalService }